import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout } from '../../../actions/auth';
import { Navigate } from 'react-router-dom';
import { getDayWeeks, updateBusinessDays, updateBusinessOpenHours, updateBusinessCloseHours } from '../../../actions/day_weeks';
import Spinner from '../../layout/Spinner';
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import Switch from "react-switch";
import moment from "moment";


const BusinessHours = ({ updateBusinessDays, updateBusinessOpenHours, updateBusinessCloseHours, getDayWeeks, day_week: { day_weeks, loading } }) => {


    // set state data - business hours from api
    const [data, setData] = useState([{
        closingTime
            :
            '',
        dayOfWeek
            :
            '',
        id
            :
            '',
        open
            :
            '',
        openingTime
            :
            '',
        weekName
            :
            ''
    }]);

    //Switch toggle status state 
    const [openStatus, setOpenStatus] = useState({ id: '', open: '' });


    const [openTime, setOpenTime] = useState({ tid: '', openingTime: '' });
    const [closeTime, setCloseTime] = useState({ ctid: '', closingTime: '' });

    useEffect(() => {
        getDayWeeks();
    }, [getDayWeeks]);

    // //SET api data to state on effect - setData
    useEffect(() => {
        let result = [];

        day_weeks.map((day_week) => {
            return result.push({
                closingTime
                    :
                    day_week.closingTime ? moment(day_week.closingTime, 'HH:mm') : null,
                dayOfWeek
                    :
                    day_week.dayOfWeek,
                id
                    :
                    day_week.id,
                open
                    :
                    day_week.open,
                openingTime
                    :
                    day_week.openingTime ? moment(day_week.openingTime, 'HH:mm') : null,
                weekName
                    :
                    day_week.weekName
            })
        });
        setData(result);
    }, [loading]);





    //Declare switch toggle variables to openStatus and change event set to setOpenStatus
    let { id, open } = openStatus;
    let { tid, openingTime } = openTime;
    let { ctid, closingTime } = closeTime;


    const onChange = e => setOpenStatus({ ...openStatus, [e.target.name]: e.target.value });


    //Switch toggle toggle change event here
    const handleToggle = (buttonId) => {
        id = buttonId;
        tid = buttonId;
        ctid = buttonId;
        openingTime = '';
        closingTime = '';
        const updatedCheckboxes = data.map((checkbox) => {
            if (checkbox.id === buttonId) {
                open = !checkbox.open;
                open = open === true ? 1 : 0
                setOpenStatus({ id, open });
                if (open === 0 || open === false) {
                    updateBusinessOpenHours({ tid, openingTime });
                    updateBusinessCloseHours({ ctid, closingTime });
                }
                return { ...checkbox, open: !checkbox.open };
            } else {
                return checkbox;
            }
        }

        );
        setData(updatedCheckboxes);
        updateBusinessDays({ id, open });
    };




    const handleOpenTime = async (index, value, open_id) => {


        openingTime = value;
        tid = open_id;
        setOpenTime({ tid, openingTime });
        updateBusinessOpenHours({ tid, openingTime });
        const updatedDays = [...data];
        updatedDays[index].openingTime = moment(value, 'HH:mm');
        setData(updatedDays);


    }

    const handleSave = () => {
        data.forEach(day => {
            const open = day.open ? 1 : 0;
            const openingTime = day.openingTime ? day.openingTime.format('HH:mm') : '';
            const closingTime = day.closingTime ? day.closingTime.format('HH:mm') : '';

            updateBusinessDays({ id: day.id, open });
            updateBusinessOpenHours({ tid: day.id, openingTime });
            updateBusinessCloseHours({ ctid: day.id, closingTime });
        });
    };


    const handleCloseTime = async (index, value, close_id) => {
        closingTime = value;
        ctid = close_id;
        setCloseTime({ ctid, closingTime });
        updateBusinessCloseHours({ ctid, closingTime });
        const updatedDays = [...data];
        updatedDays[index].closingTime = moment(value, 'HH:mm');
        setData(updatedDays);

    }


    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage p-4'>
                    <h2>Business Working Hours</h2>
                    <div className='p-4'>
                        <h5 className='mb-4'>Open Hours</h5>
                        <table className='table w-50'>
                            <tbody>
                                {loading ? <Spinner /> : data.map((day_week, index) => (
                                    <tr key={day_week.id} id={day_week.id} className='d-flex'>
                                        <td className='d-none' name='id' key={`id-${day_week.id}`} value={day_week.id} onChange={e => onChange(e)}>{day_week.id}</td>
                                        <td className='align-self-center' key={`week-${day_week.id}`} width='200' id={`week-${day_week.dayOfWeek}`} value={day_week.dayOfWeek}>{day_week.weekName}</td>
                                        <td key={`toggle-${day_week.id}`}>
                                            <Switch
                                                checked={day_week.open}
                                                onChange={() => handleToggle(day_week.id)}
                                                onColor="#86d3ff"
                                                name='open'
                                                value={data.includes(day_week.id) ? 1 : 0}
                                                onHandleColor="#2693e6"
                                                handleDiameter={30}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                height={20}
                                                width={48} className="react-switch"
                                                id={`material-switch${day_week.id}`} /></td>
                                        {day_week.open ? <td key={`open-${day_week.id}`}>
                                            <TimePicker
                                                placeholder="Opens at"
                                                use12Hours
                                                name='openingTime'
                                                showSecond={false}
                                                focusOnOpen={true}
                                                format="hh:mm A"
                                                value={day_week.openingTime}
                                                onChange={(e) => {
                                                    return handleOpenTime(index, e === null ? '10:00' : e.format('HH:mm'), day_week.id)
                                                }}
                                                id={`open-${day_week.id}`}

                                            />

                                        </td> : <td width='200'></td>
                                        }
                                        {day_week.open ? <td key={`close-${day_week.id}`}> <TimePicker
                                            placeholder="Closes at"
                                            use12Hours
                                            name='closingTime'
                                            showSecond={false}
                                            focusOnOpen={true}
                                            onChange={(e) => handleCloseTime(index, e === null ? '19:00' : e.format('HH:mm'), day_week.id)}
                                            value={day_week.closingTime}
                                            format="hh:mm A"
                                            id={`close-${day_week.id}`}
                                        />
                                        </td> : <td width='200'></td>}

                                    </tr>
                                ))}

                            </tbody>
                        </table>
                        <button className="btn btn-custom mt-3" onClick={handleSave}>
                            Save All Changes
                        </button>

                    </div>


                </div>
            </div>
        </Fragment>
    )
}

BusinessHours.propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    day_week: PropTypes.object.isRequired,
    getDayWeeks: PropTypes.func.isRequired,
    updateBusinessDays: PropTypes.func.isRequired,
    updateBusinessOpenHours: PropTypes.func.isRequired,
    updateBusinessCloseHours: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    day_week: state.day_week
});

export default connect(mapStateToProps, { updateBusinessDays, updateBusinessOpenHours, updateBusinessCloseHours, getDayWeeks, logout })(BusinessHours);


